export const _SUCCESS = "_SUCCESS";
export const _FAILURE = "_FAILURE";
export const FETCH_COMMENTS_REQUEST = "FETCH_COMMENTS_REQUEST";
export const UPDATE_COMMENT_REQUEST = "UPDATE_COMMENT_REQUEST";
export const ADD_FILTER_VALUES_FOR_COMMENTS = "ADD_FILTER_VALUES_FOR_COMMENTS";
export const FETCH_COMMENT_STATUS_REQUEST = "FETCH_COMMENT_STATUS_REQUEST";
export const FETCH_COMMENTS_TAGS_REQUEST = "FETCH_COMMENTS_TAGS_REQUEST";
